import React from 'react';
import { Button, Typography, Box, useTheme } from '@material-ui/core';
import CustomModal from '../../common/CustomModal/CustomModal';
import { useTranslation } from 'react-i18next';
import i18nNamespaces from '../../../const/i18nNamespaces';
import { P1Response } from '../../../types/p1Service';
import { IssueReferralResponse, ReferralVerificationResult } from '../../../types/referrals';
import WarningIcon from '../../common/icons/WarningIcon/WarningIcon';
import ErrorIcon from '../../common/icons/ErrorIcon/ErrorIcon';
import { P1_ERROR_SUFFIX } from '../../../const/p1';
import { P1_WARNING_SUFFIX } from '../../../const/p1';

interface ReferralP1MessagePopupProps {
    open: boolean;
    onClose: () => void;
    p1Response?: P1Response<IssueReferralResponse>;
}

const ReferralP1MessagePopup: React.FC<ReferralP1MessagePopupProps> = ({
    open,
    onClose,
    p1Response,
}) => {
    const {t: commonT} = useTranslation(i18nNamespaces.COMMON);
    const {t} = useTranslation(i18nNamespaces.ERRORS);
    const results = p1Response?.result?.results;
    const isSuccess = p1Response?.isSuccess;
    const message = p1Response?.message;

    const getMessageIconByResult = (result: string) => {
        if (result.endsWith(P1_WARNING_SUFFIX)) {
            return <WarningIcon />;
        } else if (result.endsWith(P1_ERROR_SUFFIX)) {
            return <ErrorIcon />;
        }
    }

    const formatMessage = (message: ReferralVerificationResult) => 
        `${message.code} - ${message.description}`;

    const getTitle = () => {
        if(isSuccess) {
            return t('successConfirmationPopupTitle.referral');
        } else {
            return t('noSuccessConfirmationPopupTitle.referral');
        }
    }

    return (
        <CustomModal open={open} onClose={onClose}>
            <>
            <Box display="flex" flexDirection="column" alignItems="center">
                <Typography style={{fontWeight: 'bold', textAlign: 'center', marginBottom: 16}} gutterBottom>
                    {getTitle()}
                </Typography>
                {!isSuccess && results?.length === 0 && <span>{t('noSuccessConfirmationPopupDescription')}</span>}
                {results?.map((result, index) => (
                    <Box key={index} style={{display: 'flex', alignItems: 'flex-start', gap: 8}} mb={1}>
                        {getMessageIconByResult(result.result)} {formatMessage(result)}
                    </Box>
                ))}
                <Button 
                    variant="contained" 
                    color="secondary" 
                    onClick={onClose} 
                    style={{marginTop: 8}} 
                    fullWidth
                >
                    {isSuccess ? commonT('goBack') : commonT('close')}
                </Button>
            </Box>
            </>
        </CustomModal>
    );
};

export default ReferralP1MessagePopup;